import { useFormContext } from 'react-hook-form';
import { DividerList, ContentSection } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Grid } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { UncontrolledNumberInputField } from '@mews-commander/form';
import { FormValues } from '../../schema';
import {
    CancellationPolicyDeadlineFormSection,
    CancellationPolicyFormField,
    CancellationPolicyGeneralFormSection,
    FeeExtentField,
} from '../../../../cancellationPolicies';

interface Props {
    shouldDisableBookablePeriodField: boolean;
}

export const CancellationPolicyFormContent = ({ shouldDisableBookablePeriodField }: Props) => {
    const { watch } = useFormContext<FormValues>();
    const bookablePeriod = watch(CancellationPolicyFormField.BookablePeriod);
    const relativeFee = watch(CancellationPolicyFormField.RelativeFee);

    return (
        <DividerList spacing="400">
            <CancellationPolicyGeneralFormSection
                shouldDisableBookablePeriodField={shouldDisableBookablePeriodField}
                requireKeyField
            />
            <ContentSection title={lt('Fee')}>
                <Grid templateColumns="1fr 1fr 1fr" gap="100">
                    <UncontrolledNumberInputField
                        name={CancellationPolicyFormField.RelativeFee}
                        label={lt('GeneralPercentage')}
                        type="number"
                        suffix={UnicodeEntity.Percent}
                    />
                    <FeeExtentField bookablePeriod={bookablePeriod} disabled={relativeFee === 0} />
                    <UncontrolledNumberInputField
                        name={CancellationPolicyFormField.FeeMaximumTimeUnits}
                        label={lt('CancellationPolicyMaxPeriodsToApplyFee')}
                        type="number"
                        disabled={relativeFee === 0}
                    />
                </Grid>
                <UncontrolledNumberInputField
                    name={CancellationPolicyFormField.AbsoluteFee}
                    helper={lt('CancellationPolicyAbsoluteFeeCurrencyHelper')}
                    label={lt('GeneralFixedAmount')}
                    type="number"
                />
            </ContentSection>

            <CancellationPolicyDeadlineFormSection />
        </DividerList>
    );
};
